export const MissingConfig = () => (
  <div className="flex min-h-screen items-center justify-center bg-telekinesis-bg-secondary-dark">
    <div className="max-w-xl px-4 text-center text-[#DA291C]">
      Missing API Keys. Please copy .env.local.template to .env.local and
      restart.
    </div>
  </div>
);
